import React, { ReactNode } from "react";
import HorizontalRule from "../../Rule/Horizontal";

type Props = { title: ReactNode; children: ReactNode };

export default function HistoryDetailRow({ title, children }: Props) {
  return (
    <>
      <HorizontalRule margin="0" />
      <div className="py-1.5 flex gap-2.5">
        <div className="py-3 text-sm text-brand-neutral-60 w-[90px] min-w-[90px]">
          {title}
        </div>
        <div className="p-2.5 flex flex-col gap-[5px]">{children}</div>
      </div>
    </>
  );
}
